/* ============================================================
   TheMeowPicks - theme helper (tmp.js)
   1) Scroll reveal for ".tmp .reveal" -> adds ".in"
   2) Desktop nav dropdowns open on hover
   3) Product carousels: turns ".tmp-grid4" rows into a
      horizontal slider with prev/next arrows
   Loaded per-section via <script src="{{ 'tmp.js' | asset_url }}" defer>.
   NOTE: this is the real theme helper. Do not overwrite it with the
   wishlist engine (that lives in assets/tmp-wishlist.js).
   ============================================================ */
(function () {
  if (window.__tmpInit) return;
  window.__tmpInit = true;

  /* ---------- 1. scroll reveal ---------- */
  function init() {
    var els = document.querySelectorAll('.tmp .reveal:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -36px 0px' });
    els.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 4, 3) * 0.05 + 's';
      io.observe(el);
    });
  }

  /* ---------- 2. desktop nav dropdown on hover ---------- */
  function initHover() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    var dets = document.querySelectorAll('.header__inline-menu details, header-menu details');
    dets.forEach(function (d) {
      if (d.__tmpHover) return;
      d.__tmpHover = true;
      var summary = d.querySelector('summary');
      var timer = null;
      function open() {
        clearTimeout(timer);
        dets.forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
        d.setAttribute('open', '');
      }
      function close() { timer = setTimeout(function () { d.removeAttribute('open'); }, 140); }
      d.addEventListener('mouseenter', open);
      d.addEventListener('mouseleave', close);
      if (summary) summary.addEventListener('focus', open);
    });
  }

  /* ---------- 3. product carousels ---------- */
  function carouselCss() {
    if (document.getElementById('tmp-cx-css')) return;
    var s = document.createElement('style');
    s.id = 'tmp-cx-css';
    s.textContent =
      '.tmp-cx-wrap{position:relative;}' +
      '.tmp-grid4.tmp-cx{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;scrollbar-width:none;gap:clamp(14px,1.6vw,24px);padding-bottom:2px;}' +
      '.tmp-grid4.tmp-cx::-webkit-scrollbar{display:none;}' +
      '.tmp-grid4.tmp-cx>.tmp-prod{flex:0 0 calc((100% - 3*clamp(14px,1.6vw,24px))/4);scroll-snap-align:start;}' +
      '@media(max-width:900px){.tmp-grid4.tmp-cx>.tmp-prod{flex-basis:calc((100% - clamp(14px,1.6vw,24px))/2);}}' +
      '@media(max-width:480px){.tmp-grid4.tmp-cx>.tmp-prod{flex-basis:82%;}}' +
      '.tmp-cx-btn{position:absolute;transform:translateY(-50%);z-index:4;width:44px;height:44px;border-radius:50%;border:1px solid var(--line,#E4E0D5);background:#fff;color:#15140F;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 6px 18px rgba(21,20,15,.10);transition:opacity .25s ease,background .2s ease,color .2s ease;}' +
      '@media(hover:hover){.tmp-cx-btn:hover{background:#15140F;color:#F8F7F2;border-color:#15140F;}}' +
      '.tmp-cx-btn svg{width:17px;height:17px;}' +
      '.tmp-cx-prev{left:-6px;}' +
      '.tmp-cx-next{right:-6px;}' +
      '.tmp-cx-btn[disabled]{opacity:0;pointer-events:none;}' +
      '@media(max-width:600px){.tmp-cx-btn{width:38px;height:38px;}.tmp-cx-btn svg{width:15px;height:15px;}}';
    (document.head || document.documentElement).appendChild(s);
  }

  function build(grid) {
    if (!grid || grid.classList.contains('tmp-cx')) return;
    if (!grid.querySelector('.tmp-prod')) return;
    carouselCss();
    grid.classList.add('tmp-cx');

    var wrap = document.createElement('div');
    wrap.className = 'tmp-cx-wrap';
    grid.parentNode.insertBefore(wrap, grid);
    wrap.appendChild(grid);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'tmp-cx-btn tmp-cx-prev';
    prev.setAttribute('aria-label', 'Previous');
    prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M15 6l-6 6 6 6"/></svg>';
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'tmp-cx-btn tmp-cx-next';
    next.setAttribute('aria-label', 'Next');
    next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M9 6l6 6-6 6"/></svg>';
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function step() {
      var card = grid.querySelector('.tmp-prod');
      var cw = card ? card.getBoundingClientRect().width : grid.clientWidth / 2;
      var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 20;
      var per = Math.max(1, Math.round(grid.clientWidth / (cw + gap)));
      return per * (cw + gap);
    }
    function upd() {
      var pim = grid.querySelector('.tmp-pim');
      var top = pim ? pim.getBoundingClientRect().height / 2 : grid.clientHeight / 2;
      prev.style.top = next.style.top = top + 'px';
      var max = grid.scrollWidth - grid.clientWidth - 2;
      var overflow = grid.scrollWidth > grid.clientWidth + 4;
      prev.style.display = next.style.display = overflow ? '' : 'none';
      if (grid.scrollLeft <= 2) prev.setAttribute('disabled', ''); else prev.removeAttribute('disabled');
      if (grid.scrollLeft >= max) next.setAttribute('disabled', ''); else next.removeAttribute('disabled');
    }
    prev.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });
    grid.addEventListener('scroll', function () { window.requestAnimationFrame(upd); });
    window.addEventListener('resize', upd);
    setTimeout(upd, 60);
    setTimeout(upd, 400);
  }

  function initTmpCarousels() {
    var grids = document.querySelectorAll('.tmp-grid4:not(.product-grid):not(.tmp-cx)');
    for (var i = 0; i < grids.length; i++) {
      if (grids[i].querySelector('.tmp-prod')) build(grids[i]);
    }
  }

  /* ---------- run + re-run on section load / DOM changes ---------- */
  function run() { init(); initHover(); initTmpCarousels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
  try {
    var t, mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 120); });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();